import React from "react";

const ActualTips = ({ row }) => {
  return <div>{row?.actualTips?.toLocaleString()}</div>;
};

export default ActualTips;
